<div
  class="tag"
  [class]="tag.isSystemTag ? tag.class : ''"
  [style]="{
    '--tag-color': customColor,
    '--tag-bg-color': backgroundColor,
  }"
  (click)="onClickTag()"
>
  <span>{{ tag.name }}</span>
  <ng-content />
</div>
